import { render, staticRenderFns } from "./ReducingDeciLayerSelect.vue?vue&type=template&id=18852206&"
import script from "./ReducingDeciLayerSelect.vue?vue&type=script&lang=js&"
export * from "./ReducingDeciLayerSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports